import { useEffect, useState } from "react";
import { Star } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

/** Live-Aggregatnote des eigenen DIMEDIAL-Google-Profils. Rendert nur, wenn echte Daten vorliegen – keine Fabrikation. */
export const GoogleRatingBadge = ({ className = "", compact = false }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/google/studio-rating`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d && d.available) setData(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!data) return null;
  const note = Number(data.rating).toFixed(1).replace(".", ",");
  if (compact) {
    return (
      <a
        href={data.maps_url}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-1.5 rounded-full border border-[#111]/15 bg-white px-2.5 py-1 transition-colors hover:border-[#111]/40 ${className}`}
        aria-label={`${note} von 5 Sternen bei Google aus ${data.count} Bewertungen – Google-Profil öffnen`}
        data-testid="google-rating-badge-compact">
        <Star size={13} className="fill-[#FDD105] text-[#FDD105]" aria-hidden="true" />
        <span className="text-xs font-bold text-[#111]">{note}</span>
        <span className="text-[11px] text-[#6B6760]">Google</span>
      </a>
    );
  }
  return (
    <a
      href={data.maps_url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 rounded-full border-2 border-[#111] bg-white px-3.5 py-1.5 shadow-[3px_3px_0_#111] transition-transform hover:-translate-y-0.5 ${className}`}
      aria-label={`${note} von 5 Sternen bei Google aus ${data.count} Bewertungen – Google-Profil öffnen`}
      data-testid="google-rating-badge">
      <span className="flex items-center gap-0.5" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star
            key={i}
            size={14}
            className={i < Math.round(data.rating) ? "fill-[#FDD105] text-[#FDD105]" : "fill-[#111]/10 text-[#111]/20"}
          />
        ))}
      </span>
      <span className="text-xs font-bold text-[#111]" data-testid="google-rating-value">{note}</span>
      <span className="text-xs text-[#4A4A4A]">· {data.count} Google-Bewertungen</span>
    </a>
  );
};
